import React from 'react'
import ProjectCard from './ProjectCard'
import "./Project.css"
import sampleImg from "./Project_Images/sampleImg.png"

const Project = () => {
    return (
        <>
            {/* <!-- MANIN Area Project --> */}
            <section className='mainSection'>
                <section className='mainChidOne'>
                    <div class="projects_title">
                        <h3>Explore our</h3>
                        <h1>Projects</h1>
                        <hr />
                    </div>


                    {/* <!-- buttons --> */}
                    <div class="projects_btn">
                        <div class="btn mainBtn">
                            <ul>
                                <li><a class="active" href="#">Web Developement</a></li>
                                <li><a href="#">Graphic Design</a></li>
                                <li><a href="#">Content Writing</a></li>
                                <li><a href="#">Blockchain</a></li>
                            </ul>
                        </div>
                        <div class="btn subBtn">
                            <ul>
                                <li><a class="active" href="#">Landing page</a></li>
                                <li><a href="#">Frontend</a></li>
                                <li><a href="#">NFT</a></li>
                                <li><a href="#">Functionality</a></li>
                                <li><a class="last_subBtn" href="#">Full stack</a></li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* CARDS Start */}
                <div class="card_main">
                    <ProjectCard title="Rhenyz" color="-webkit-linear-gradient(270deg, hsla(211, 82%, 35%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                    <ProjectCard title="2584 Design" color="-webkit-linear-gradient(270deg, hsla(180, 83%, 40%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                    <ProjectCard title="Sebrapage" color="-webkit-linear-gradient(270deg, hsla(272, 65%, 37%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                    <ProjectCard title="Automation" color="-webkit-linear-gradient(270deg, hsla(0, 79%, 72%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                    <ProjectCard title="Kitab" color="-webkit-linear-gradient(270deg, hsla(52, 67%, 49%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                    <ProjectCard title="EBookLP" color="-webkit-linear-gradient(270deg, hsla(138, 39%, 52%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
                </div>

            </section>
        </>
    )
}

export default Project
